var CoreObject = require("enyo/CoreObject"),
    Store      = new CoreObject(),
    kind       = require("enyo/kind");

/**
 * Adds support to store scrollAnchor position and recall it later.
 *
 * @mixin app.ui.ScrollAnchorMemorySupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "app.ui.ScrollAnchorMemorySupport",

    /**
     * @memberof  app.ui.ScrollAnchorMemorySupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            this.observe("anchor", this.memorizeAnchor);
        };
    }),

    /**
     * @memberof  app.ui.ScrollAnchorMemorySupport
     * @method
     * @public
     */
    memorizeAnchor: function() {
        var key    = this.get("anchorKey"),
            anchor = this.get("anchor");

        key && anchor && Store.set(key, anchor);
    },

    /**
     * @memberof  app.ui.ScrollAnchorMemorySupport
     * @method
     * @public
     */
    clearMemorizedAnchor: function() {
        var key = this.get("anchorKey");

        if (key) {
            Store.set(key, {
                index:      this.prefixHeight !== undefined ? -1 : 0,
                offsetLeft: 0,
                offsetTop:  0
            });
        }
    },

    /**
     * @param     {bool}  preventSnap  Don't snap to the anchor
     * @memberof  app.ui.ScrollAnchorMemorySupport
     * @method
     * @public
     */
    restoreAnchor: function() {
        var key = this.get("anchorKey"),
            anchor;

        anchor = Store.get(key);

        if (anchor) {
            this.set("anchor", anchor);
            this.snapToAnchor();
        }
        else {
            this.set("anchor", {
                index:      this.prefixHeight !== undefined ? -1 : 0,
                offsetLeft: 0,
                offsetTop:  0
            });
        }
    }

};
